import dashboard from 'assets/icons/dashboard.svg';
import profile from 'assets/icons/profile.svg';
import pipeline from 'assets/icons/pipeline.svg';
import documents from 'assets/icons/document.svg';
import tools from 'assets/icons/tools.svg';
import help from 'assets/icons/help.svg';
import reportsIcon from 'assets/icons/reportsIcon.svg';
import adminIcon from 'assets/icons/adminIcon.svg';
import consumerIcon from 'assets/icons/consumerIcon.svg';
import quickPrice from 'assets/icons/quickPrice.svg';
import reports from 'assets/icons/reports.svg';
import admin from 'assets/icons/admin.svg';
import { canAccessSection, SECTIONS } from '../../utils/accessControl';
import { normalizeRole } from '../../utils/roles';

export const navItems = [
  {
    title: 'Dashboard',
    icon: <img src={dashboard} alt="dashboard"></img>,
    path: '/dashboard',
    role: [
      'consumer',
      'loanOfficer',
      'organization',
      'superAdmin',
      'branchAdmin',
      'loanProcessor',
    ],
  },
  {
    title: 'Profile',
    icon: <img src={profile} alt="profile"></img>,
    path: '/profile',
    role: ['consumer'],
  },
  {
    title: 'Loan Information',
    icon: <img src={profile} alt="loan"></img>,
    path: '/loanInformation',
    role: ['loanOfficer', 'organization', 'superAdmin', 'branchAdmin', 'loanProcessor', 'leadGen'],
    subPaths: ['/loanInformation'],
  },
  {
    title: 'Pipeline',
    icon: <img src={pipeline} alt="pipeline"></img>,
    path: '/pipeline',
    role: [
      'loanOfficer',
      'organization',
      'superAdmin',
      'branchAdmin',
      'loanProcessor',
    ],
    subPaths: ['/pipeline'],
  },
  {
    title: 'My Applications',
    icon: <img src={pipeline} alt="pipeline"></img>,
    path: '/pipeline',
    role: ['consumer'],
    subPaths: ['/pipeline'],
  },
  {
    title: 'Quick Price',
    icon: <img src={quickPrice} alt="quickPrice"></img>,
    path: '/quickPrice',
    role: ['loanOfficer', 'loanProcessor', 'organization', 'superAdmin', 'branchAdmin'],
  },
  {
    title: 'Documents',
    icon: <img src={documents} alt="documents"></img>,
    path: '/documents',
    role: ['consumer'],
  },
  {
    title: 'Tools',
    icon: <img src={tools} alt="tools"></img>,
    path: '/tools',
    role: [
      'consumer',
      'organization',
      'loanOfficer',
      'superAdmin',
      'branchAdmin',
      'loanProcessor',
    ],
  },
  {
    // Borrower-only: B2B has no Help item in the rail. Route: consumer.jsx
    // 'help-support' (shared Help & Support page).
    title: 'Help',
    icon: <img src={help} alt="help"></img>,
    path: '/help-support',
    role: ['consumer'],
  },
  {
    title: 'Admin',
    icon: <img src={admin} alt="admin"></img>,
    path: '/admin/employees',
    subPaths: ['/admin', '/admin/consumer', '/admin/employees', '/admin/branches', '/admin/invitations'],
    section: SECTIONS.ADMIN,
  },
  {
    title: 'Reports',
    icon: <img src={reports} alt="reports"></img>,
    path: '/reports',
    role: ['organization', 'superAdmin', 'branchAdmin'],
  },
];
